/* The mockup's `.card.card-pad` with `.check-row`s. */
.card {
  padding: var(--space-4);
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.head {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  margin-block-end: var(--space-2);
}

.title {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.pairs {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.pair {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--font-size-13);
}

/* The mockup's "AA · 17,9:1": a separator drawn by the style, not read out. */
.ratio {
  font-variant-numeric: tabular-nums;
}

.ratio::before {
  content: "·";
  margin-inline-end: 4px;
}

.blocked {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: var(--space-2) 0 0;
  color: var(--danger-text);
  font-size: var(--font-size-13);
}
